var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBillDarker20Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "22px",
    viewBox: "0 0 17 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC4riklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arveldus---Arved",
    transform: "translate(-207.000000, -185.000000)",
    stroke: "#F0B423",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(0.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(208.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25-Copy-6",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L15,0 L15,0 L15,14.7826087 C15,17.6521739 12.6176471,20 9.70588235,20 L0,20 L0,20 L0,0 L0,0 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75,5.625 L11.25,5.625",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75,9.375 L11.25,9.375",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75,13.125 L8.75,13.125",
    id: "Stroke-7"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBillDarker20Px);
export default __webpack_public_path__ + "static/media/Icon_Bill_Darker_20px.634d3c01f8e2977b052ef349ca34eabf.svg";
export { ForwardRef as ReactComponent };